var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6627 5.99925L11.8625 11.199C12.0455 11.3821 12.0455 11.6789 11.8625 11.862C11.6794 12.045 11.3826 12.045 11.1995 11.862L5.99975 6.66218L0.799987 11.862C0.616917 12.045 0.320105 12.045 0.137058 11.862C-0.0459882 11.6789 -0.0460116 11.3821 0.137058 11.199L5.33682 5.99927L0.137058 0.799485C-0.0460116 0.616415 -0.0460116 0.319603 0.137058 0.136557C0.228582 0.0450335 0.348558 -0.000716209 0.468534 -0.000716209C0.588511 -0.000716209 0.708464 0.0450335 0.80001 0.136557L5.99975 5.33632L11.1995 0.136557C11.291 0.0450335 11.411 -0.000716209 11.531 -0.000716209C11.651 -0.000716209 11.7709 0.0450335 11.8625 0.136557C12.0455 0.319627 12.0455 0.616439 11.8625 0.799485L6.6627 5.99925Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.9658d9eb5a0bfae9950b90cb4c121e63.svg";
export { ForwardRef as ReactComponent };